import { render, staticRenderFns } from "./sv-panel.vue?vue&type=template&id=f0e7aa0e&"
import script from "./sv-panel.vue?vue&type=script&lang=js&"
export * from "./sv-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e7aa0e')) {
      api.createRecord('f0e7aa0e', component.options)
    } else {
      api.reload('f0e7aa0e', component.options)
    }
    module.hot.accept("./sv-panel.vue?vue&type=template&id=f0e7aa0e&", function () {
      api.rerender('f0e7aa0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/color-picker/src/components/sv-panel.vue"
export default component.exports